<template>
  <section class="section section--flush" id="team">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">04 / TEAM / 团队</p>
        <h2>谁来做你的事</h2>
        <p>四个人, 加起来三十多年从业经验。你的项目从头到尾, 由这四个人负责。</p>
      </div>
      <div class="team-grid">
        <div class="member reveal" v-for="m in members" :key="m.name" v-reveal>
          <div class="avatar">
            <img :src="m.avatar" :alt="m.name">
          </div>
          <h3>{{ m.name }}</h3>
          <p class="member-role">{{ m.role }}</p>
          <p>{{ m.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import avatarCeo from '@/assets/avatar-ceo.jpg'
import avatarCto from '@/assets/avatar-cto.jpg'
import avatarPm from '@/assets/avatar-pm.jpg'
import avatarUi from '@/assets/avatar-ui.jpg'

export default {
  name: 'TeamSection',
  data() {
    return {
      members: [
        {
          name: '雷军',
          role: '创始人 & CEO',
          desc: '12 年软件工程与交付经验，主导技术方案与项目落地',
          avatar: avatarCeo
        },
        {
          name: 'Manson',
          role: '联合创始人 & 市场负责人',
          desc: '20 年市场经验，负责品牌建设与商务合作，全程参与客户沟通',
          avatar: avatarCto
        },
        {
          name: '火龙果',
          role: '产品负责人',
          desc: '10 年大厂产品经验，负责需求梳理与产品规划',
          avatar: avatarPm
        },
        {
          name: '刘一手',
          role: '设计负责人',
          desc: '7 年 UI/UX 设计经验，负责为你的产品设计和交互把关',
          avatar: avatarUi
        }
      ]
    }
  }
}
</script>

<style scoped>
.team-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.member {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 30px 24px;
  text-align: center;
  transition: border-color 0.15s, transform 0.15s;
}

.member:hover {
  border-color: #D4D4CE;
  transform: translateY(-2px);
}

.avatar {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 18px;
  background: #EFEEE9;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.member h3 {
  font-size: 17px;
  font-weight: 600;
}

.member-role {
  font-family: var(--mono);
  font-size: 13.5px;
  color: var(--ink-2);
  margin: 6px 0 12px;
}

.member p:last-child {
  font-size: 13.5px;
  color: var(--ink-2);
}

@media (max-width: 860px) {
  .team-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
